import { render, staticRenderFns } from "./NewModuleForm.vue?vue&type=template&id=5f250916&"
import script from "./NewModuleForm.vue?vue&type=script&lang=ts&"
export * from "./NewModuleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports